import React from 'react';
import { chartIntervalSelector } from '@src/store/trends/birdChart/selectors';
import moment from 'moment';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectedCustomerIdSelector } from '@src/store/common/selectors';
import { useAllowedMonths } from '@src/components/app-session-timeline/hooks/shared/useAllowedMonths';

const InvalidIntervalContainer = styled.div`
  height: 200px;
  margin: 20px 10px;
`;

export enum InvalidIntervalType {
  USERS_TAB,
  NETWORK_REQUEST_TAB,
  ERROR_ANALYSIS_TAB,
}

export const useInvalidIntervalMessage = ({ type }: { type: InvalidIntervalType }) => {
  const interval = useSelector(chartIntervalSelector);
  const selectedCustomerId = useSelector(selectedCustomerIdSelector);
  const value = useAllowedMonths(selectedCustomerId);

  return React.useMemo(() => {
    let message = '';
    switch (type) {
      case InvalidIntervalType.USERS_TAB:
        if (moment(interval.from).isBefore(moment().subtract(value, 'M').startOf('day'))) {
          message = 'Users is only supported for last 1 month range.';
        }
        // }
        break;
      case InvalidIntervalType.ERROR_ANALYSIS_TAB:
        if (moment(interval.from).isBefore(moment().subtract(30, 'd').startOf('day'))) {
          message = 'Error Analysis is only supported for the last 30 days.';
        }
        break;
      default:
        break;
    }
    if (message) {
      return <InvalidIntervalContainer>{message}</InvalidIntervalContainer>;
    }
    return null;
  }, [interval, type, value]);
};
